module.exports = __webpack_public_path__ + "img/phone-round-gray-icon.c91e210a.svg";